'use strict';
define('elements/sly',['utils/domready', 'jquery', 'sly'], function(domready, $) {
    domready(function() {
        $('.slywrap--single').each(function() {
            var $wrap = $(this),
                $frame = $wrap.find('.frame--single'),
                slidee = $frame.find('.slidee'),
                slide = slidee.find('li'),
                slides = slidee.children().length;

            slide.css("width", 100 / slides + "%");
            slidee.css("width", 100 * slides + "%");

            // Call Sly on frame
            $frame.sly({
                horizontal: 1,
                itemNav: 'forceCentered',
                smart: true,
                activateMiddle: true,
                mouseDragging: 1,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBar: $wrap.find('.scrollbar'),
                scrollBy: 1,
                speed: 300,
                elasticBounds: 1,
                easing: 'swing',
                dragHandle: 1,
                dynamicHandle: 1,
                clickBar: 1,

                // Buttons
                prev: $wrap.find('.controls__button--prev'),
                next: $wrap.find('.controls__button--next')
            });

            $(window).on("load", function(e) {

                slide.css("width", 100 / slides + "%");
                slidee.css("width", 100 * slides + "%");

                $frame.sly('reload');
            });

            $(window).resize(function(e) {

                slide.css("width", 100 / slides + "%");
                slidee.css("width", 100 * slides + "%");

                $frame.sly('reload');
            });
        });

        $('.slywrap--multiple').each(function() {
            var $wrap  = $(this),
                $frame = $wrap.find('.frame--multiple');

            // Call Sly on frame
            $frame.sly({
                horizontal: 1,
                itemNav: 'centered',
                smart: true,
                activateMiddle: true,
                activateOn: 'click',
                mouseDragging: 1,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBar: $wrap.find('.scrollbar'),
                scrollBy: 1,
                speed: 300,
                elasticBounds: 1,
                easing: 'swing',
                dragHandle: 1,
                dynamicHandle: 1,
                clickBar: 1,

                // Buttons
                prev: $wrap.find('.controls__button--prev'),
                next: $wrap.find('.controls__button--next')
            });

            $(window).resize(function(e) {
                $frame.sly('reload');
            });

            $(window).on("load", function(e) {
                $frame.sly('reload');
            });
        });
    });
});

